import { drybulkCargoOperationsService } from "@services/drybulkCargoOperationsApi";
import { useQuery } from "@tanstack/react-query";
import { DRYBULK_CARGO_OPS_QUERY_KEYS } from "../constants";
import { gradeOptionsQuery } from "./gradeOptionsQuery";

export const useSequenceOptions = (enabled: boolean) => {
  const common = { enabled, staleTime: Infinity, refetchOnWindowFocus: false, retry: false };
  const cargoCodes = useQuery({
    ...common,
    queryKey: DRYBULK_CARGO_OPS_QUERY_KEYS.options("cargo-codes"),
    queryFn: () => drybulkCargoOperationsService.getCargoCodes(),
  });
  const grades = useQuery({ ...gradeOptionsQuery, enabled });
  const stockPiles = useQuery({
    ...common,
    queryKey: DRYBULK_CARGO_OPS_QUERY_KEYS.options("stock-piles"),
    queryFn: () => drybulkCargoOperationsService.getStockPiles(),
  });
  const shippers = useQuery({
    ...common,
    queryKey: DRYBULK_CARGO_OPS_QUERY_KEYS.options("shippers"),
    queryFn: () => drybulkCargoOperationsService.getShippers(),
  });
  const lists = [cargoCodes, grades, stockPiles, shippers];

  return {
    cargoCodes: cargoCodes.data,
    grades: grades.data,
    stockPiles: stockPiles.data,
    shippers: shippers.data,
    isLoading: lists.some((list) => list.isLoading),
    isError: lists.some((list) => list.isError),
  };
};
